export default {
  step1: '基本情報',
  step2: '商品属性',
  step3: '仕様/価格情報',
  step4: '商品詳細',
  productName: '商品名',
  productNameRequired: '商品名を入力してください',
  productNamePlaceholder: '商品名を入力してください',
  productCategory: '商品カテゴリ',
  productNo: '商品コード',
  productNoRequired: '商品コードを入力してください',
  productNoPlaceholder: '商品コードを入力してください',
  productImage: '商品画像',
  productVideo: '商品動画',
  videoCover: '動画カバー',
  videoCoverUpload: '動画カバー',
  productWeight: '商品重量',
  weightPlaceholder: '商品重量を入力してください',
  weightUnit: 'kg',
  productUnit: '商品単位',
  unitPlaceholder: '商品単位を入力してください',
  productBarcode: '商品バーコード',
  barcodePlaceholder: '商品バーコードを入力してください',
  productRetailPrice: '商品小売価格',
  retailPricePlaceholder: '商品小売価格を入力してください',
  productMarketPrice: '商品市場価格',
  marketPricePlaceholder: '商品市場価格を入力してください',
  productAttributes: '商品属性：',
  attrGroup: '属性グループ',
  attrValue: '属性値',
  action: '操作',
  attrSelectPlaceholder: '先に属性を選択してください',
  addAttr: '+ 追加',
  productSpec: '商品仕様',
  singleSpec: '単一仕様',
  multiSpec: '複数仕様',
  productPrice: '商品価格',
  priceRequired: '商品価格を入力してください',
  pricePlaceholder: '商品価格を入力してください',
  priceUnit: 'USD',
  specNamePlaceholder: '仕様名',
  specValuePlaceholder: '仕様値',
  addSpecValue: '+ 追加',
  addSpec: '+ 仕様を追加',
  generateSpec: '+ 仕様を生成',
  specImage: '仕様画像',
  specPrice: '価格(USD)',
  specWeight: '商品重量',
  specVirtualSales: '仮想販売数',
  specNo: '仕様番号',
  specNoPlaceholder: '商品番号',
  specNoRequired: '仕様番号は必須です',
  specImageRequired: '仕様画像は必須です',
  specMatrixRequired: '仕様マトリックスを先に生成してください',
  applySpecChanges: '仕様名を変更',
  select: '選択',
  productDetail: '商品詳細',
  detailPlaceholder: '本文を入力してください',
  phonePreview: '商品詳細',
};
